import { Component, h, Host } from "@stencil/core";

@Component({
    tag: "leichte-sprache-toggle-icon",
    styleUrl: "leichte-sprache-toggle-icon.scss",
    shadow: true,
})
export class LeichteSpracheToggleIcon {
    render() {
        return (
            <Host aria-hidden="true">
                <svg
                    width="400px"
                    height="400px"
                    viewBox="0 0 400 400"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <desc>Created with Sketch.</desc>
                    <defs>
                        <polygon
                            id="path-1"
                            points="0.001 0 400 0 400 400 0.001 400"
                        ></polygon>
                    </defs>
                    <g
                        id="AstronautBot-SVG"
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                    >
                        <g id="Icoon/Profile_bot_dark">
                            <g id="Group-14">
                                <g id="Group-3">
                                    <mask id="mask-2" fill="white">
                                        <use xlinkHref="#path-1"></use>
                                    </mask>
                                    <g id="Clip-2"></g>
                                    <path
                                        d="M200.001,400 C310.451,400 400.001,310.46 400.001,200 C400.001,89.55 310.451,0 200.001,0 C89.541,0 0.001,89.55 0.001,200 C0.001,310.46 89.541,400 200.001,400"
                                        id="Fill-1"
                                        fill="none"
                                        mask="url(#mask-2)"
                                    ></path>
                                </g>
                                <path
                                    d="M269.591,257.578 C249.941,271.638 225.951,279.998 200.001,279.998 C174.051,279.998 150.061,271.638 130.411,257.578 C111.681,270.158 100.001,289.898 100.001,318.268 C100.001,346.148 150.221,366.138 200.341,366.078135 C250.221,366.008 300.001,346.028 300.001,318.268 C300.001,289.898 288.321,270.158 269.591,257.578"
                                    id="Fill-4"
                                    fill="#020E25"
                                ></path>
                                <path
                                    d="M300.001,130 C298.481,130 297.011,130.23 295.551,130.45 C283.831,92.52 250.161,64.27 209.371,60.47 C209.381,60.31 209.471,60.17 209.471,60 L209.471,40 C209.471,34.48 205.001,30 199.471,30 C193.951,30 189.471,34.48 189.471,40 L189.471,60 C189.471,60.21 189.581,60.39 189.591,60.6 C149.281,64.78 116.061,92.85 104.451,130.45 C102.981,130.23 101.521,130 100.001,130 C83.431,130 70.001,143.43 70.001,160 C70.001,176.57 83.431,190 100.001,190 C101.521,190 102.981,189.77 104.451,189.55 C117.051,230.35 155.061,260 200.001,260 C244.941,260 282.941,230.35 295.551,189.55 C297.011,189.77 298.481,190 300.001,190 C316.571,190 330.001,176.57 330.001,160 C330.001,143.43 316.571,130 300.001,130"
                                    id="Fill-6"
                                    fill="#020E25"
                                ></path>
                                <path
                                    d="M234.903,300 C221.443,300 210.523,311.14 210.523,324.88 C210.523,338.62 221.443,342.1 234.903,342.1 C248.363,342.1 259.283,338.62 259.283,324.88 C259.283,311.14 248.363,300 234.903,300"
                                    id="Fill-8"
                                    fill="#EFAE00"
                                ></path>
                                <path
                                    d="M200.001,73.686 C150.591,73.686 110.531,113.746 110.531,163.156 C110.531,212.576 150.591,225.116 200.001,225.116 C249.411,225.116 289.471,212.576 289.471,163.156 C289.471,113.746 249.411,73.686 200.001,73.686"
                                    id="Fill-10"
                                    fill="#EFAE00"
                                ></path>
                                <path
                                    d="M184.21,209.858 C216.18,209.858 168.42,184.838 168.42,152.208 C168.42,119.578 216.18,90.608 184.21,90.608 C152.24,90.608 126.31,126.458 126.31,159.088 C126.31,191.728 152.24,209.858 184.21,209.858"
                                    id="Fill-12"
                                    fill="#FFCE1F"
                                ></path>
                            </g>
                        </g>
                    </g>
                </svg>
            </Host>
        );
    }
}
